export default __webpack_public_path__ + "static/media/image-14.9a3a40fa.png";